import React from 'react';
import { Switch } from '@/Components/shadcn/switch';
import { Label } from '@/Components/shadcn/label';

export interface LabeledSwitchProps {
    label: string;
    checked?: boolean;
    disabled?: boolean;
    onCheckedChange?: (checked: boolean) => void;
    name?: string;
}

function LabeledSwitch({ label, checked, disabled, onCheckedChange, name }: LabeledSwitchProps): React.JSX.Element {
    return (
        <div className="flex items-center gap-4">
            <Switch id={name} checked={checked} disabled={disabled} onCheckedChange={onCheckedChange} />
            <Label htmlFor={name} className="cursor-pointer text-sm leading-none font-normal">
                {label}
            </Label>
        </div>
    );
}

export default LabeledSwitch;
